import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Package } from "lucide-react";
import api, { brl } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Account() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (!loading && !user) navigate("/login");
  }, [user, loading, navigate]);

  useEffect(() => {
    if (user) api.get("/orders").then((r) => setOrders(r.data)).catch(() => {});
  }, [user]);

  if (!user) return null;

  return (
    <div className="mx-auto max-w-[1000px] px-4 pb-24 pt-10 sm:px-6">
      <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-clay">Minha conta</p>
      <h1 className="mt-3 font-serif text-5xl font-light text-forest-deep">Olá, {user.name.split(" ")[0]}</h1>
      <p className="mt-2 font-sans text-sm text-ink/60">{user.email}</p>

      <div className="mt-12">
        <h2 className="mb-6 font-serif text-3xl text-forest-deep">Histórico de pedidos</h2>
        {orders.length === 0 ? (
          <div className="border border-dashed border-borderlight py-16 text-center">
            <Package className="mx-auto text-ink/30" size={32} />
            <p className="mt-4 font-sans text-sm text-ink/60">Você ainda não fez nenhum pedido.</p>
            <button onClick={() => navigate("/loja")} data-testid="account-shop-btn"
              className="mt-6 bg-forest-deep px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] text-alabaster hover:bg-clay">
              Explorar Coleção
            </button>
          </div>
        ) : (
          <div className="space-y-4">
            {orders.map((o) => (
              <div key={o.id} data-testid={`order-${o.order_number}`} className="border border-borderlight bg-white p-6">
                <div className="flex flex-wrap items-center justify-between gap-3 border-b border-borderlight pb-4">
                  <div>
                    <p className="font-mono text-xs uppercase tracking-widest text-clay">{o.order_number}</p>
                    <p className="mt-1 font-sans text-xs text-ink/50">{new Date(o.created_at).toLocaleDateString("pt-BR")}</p>
                  </div>
                  <span className="bg-forest-deep/10 px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-forest-deep">{o.status}</span>
                </div>
                <div className="mt-4 space-y-2">
                  {o.items.map((it) => (
                    <div key={it.product_id} className="flex justify-between font-sans text-sm text-ink/80">
                      <span>{it.quantity}× {it.name}</span>
                      <span>{brl(it.price * it.quantity)}</span>
                    </div>
                  ))}
                </div>
                <div className="mt-4 flex justify-between border-t border-borderlight pt-4 font-serif text-xl text-forest-deep">
                  <span>Total</span><span>{brl(o.total)}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
